<template>
  <header class="app-header navbar">
    <button class="navbar-toggler mobile-sidebar-toggler d-lg-none" type="button" @click="mobileSidebarToggle">
      <span class="navbar-toggler-icon"></span>
    </button>
    <b-link class="navbar-brand" to="/orgs"></b-link>
    <button class="navbar-toggler sidebar-toggler d-lg-down-none" type="button" @click="sidebarToggle">
      <span class="navbar-toggler-icon"></span>
    </button>
    <breadcrumb/>
    <div class="header-actions">
      <a v-if="!xsBootstrap" class="new-console-link" href="https://console.fareclock.com?from-legacy" @click.prevent="goToNewConsole">
        <font-awesome-icon icon="arrow-up-right-from-square" class="icon" />
        <span>Try New Console</span>
      </a>
      <referral-header-dropdown v-if="showReferralDropdown" />
      <notification-bell v-if="dashboardNotificationsEnabled" />
      <help-header-dropdown />
      <user-header-dropdown/>
    </div>
    <div v-if="xsBootstrap" class="new-console-mobile-row">
      <a class="new-console-link" href="https://console.fareclock.com?from-legacy" @click.prevent="goToNewConsole">
        <font-awesome-icon icon="arrow-up-right-from-square" class="icon" />
        <span>Try New Console</span>
      </a>
    </div>
  </header>
</template>
<script>
import UserHeaderDropdown from './UserHeaderDropdown.vue'
import Breadcrumb from './Breadcrumb.vue'
import HelpHeaderDropdown from '../components/HelpHeaderDropdown.vue'
import ReferralHeaderDropdown from '../components/ReferralHeaderDropdown.vue'
import NotificationBell from '../components/NotificationBell.vue'
import { mapState } from 'vuex'
import constants from '@/constants'

const oConstants = constants()
const NEW_CONSOLE_URL = 'https://console.fareclock.com'
const NEW_CONSOLE_PREFERENCE_KEY = 'NEW_CONSOLE_FROM_LEGACY'

export default {
  name: 'c-header',
  inheritAttrs: false,
  components: {
    Breadcrumb,
    UserHeaderDropdown,
    HelpHeaderDropdown,
    ReferralHeaderDropdown,
    NotificationBell
  },
  computed: {
    ...mapState({
      dashboardNotificationsEnabled: state => state.dashboardNotifications.running
    }),
    ...mapState('size', ['clientWidth']),
    ...mapState('userProfile', ['countryCode']),
    xsBootstrap () {
      return this.clientWidth < oConstants.bootstrap.md
    },
    showReferralDropdown () {
      // Do not show referral dropdown for PH users
      return this.countryCode !== 'PH'
    }
  },
  methods: {
    goToNewConsole () {
      window.localStorage.setItem(NEW_CONSOLE_PREFERENCE_KEY, '1')
      window.location.assign(`${NEW_CONSOLE_URL}?from-legacy`)
    },
    sidebarToggle (e) {
      e.preventDefault()
      document.body.classList.toggle('sidebar-hidden')
    },
    mobileSidebarToggle (e) {
      e.preventDefault()
      document.body.classList.toggle('sidebar-mobile-show')
    }
  }
}
</script>
<style scoped>
.app-header {
  justify-content: flex-start;
  flex-wrap: nowrap;
  width: 100%;
  z-index: 1102 !important; /* higher than p-sidebar's z-index of 1101 */
}

/* Change default core-ui behavior such that when below lg width,
   the brand will be minimized even if navbar is not.*/
@media (max-width: 1200px) {
  .app-header.navbar :deep(.navbar-brand) {
      min-width: 24px;
      width: var(--navbar-brand-minimized-width);
      margin-left: -3px;
      margin-right: 4px;
      background-color: var(--navbar-brand-minimized-bg);
      background-image: var(--navbar-brand-minimized-logo);
      background-size: var(--navbar-brand-minimized-logo-size);    
  }
}

.navbar-toggler {
  border: none;
  box-shadow: none;
}

.header-actions {
  margin-left: auto;
  display: flex;
  align-items: center;
  flex-shrink: 0;
}

.new-console-link {
  margin-right: 0.5rem;
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
  font-size: 0.78rem;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-decoration: none;
  color: var(--legacy-theme-primary);
}

.new-console-link:hover,
.new-console-link:focus {
  color: var(--legacy-theme-primary);
  opacity: 0.85;
  text-decoration: none;
}

.new-console-link .icon {
  font-size: 0.8rem;
}

.new-console-mobile-row {
  display: none;
}

.new-console-mobile-row .new-console-link {
  margin-right: 0;
  font-size: 0.72rem;
  letter-spacing: 0.03em;
}

@media (max-width: 767px) {
  .new-console-mobile-row {
    position: fixed;
    top: 57px;
    right: 0.5rem;
    display: inline-flex;
    justify-content: flex-end;
    z-index: 1103;
  }

  :global(body .app-header.navbar) {
    min-height: 88px;
    height: 88px;
    padding-bottom: 33px;
  }

  :global(body .app-body) {
    margin-top: 88px;
  }

  .new-console-link {
    margin-right: 0.2rem;
    font-size: 0.72rem;
    letter-spacing: 0.03em;
  }
}

.d-lg-none {
  @apply tw:inline-block tw:lg:hidden;
}

.d-lg-down-none {
  @apply tw:hidden tw:lg:inline-block;
}

</style>
